import { C } from "../../lib/constants";

export const BottomNav = ({screen, setScreen, user}) => {
  const tabs = [
    {id:"home",   label:"Inicio", icon:"🏠"},
    {id:"search", label:"Buscar", icon:"🔍"},
    {id:"obra",   label:"Mi Obra",icon:"🏗️"},
    {id:"cuenta", label:"Cuenta", icon:"👤"},
  ];
  const map = {
    home:   ["landing","obra-activa"],
    search: ["directory","workerProfile","supervision-flow"],
    obra:   ["buscar-ayudante","solicitudes-worker","trabajos-cliente","calificar-trabajo"],
    cuenta: ["cuenta","portal-cliente","perfil-cliente","reg-worker","reg-client",
             "reg-supervisor","cliente-login","worker-login","clientes-list","admin"]
  };
  const active = Object.entries(map).find(([,screens])=>screens.includes(screen))?.[0]||"home";
  const go = (id) => {
    if (id==="home")   return setScreen("landing");
    if (id==="search") return setScreen(user ? "directory" : "cliente-login");
    if (id==="obra")   return setScreen(user ? "obra-activa" : "cliente-login");
    if (id==="cuenta") return setScreen(user ? "cuenta" : "cliente-login");
  };
  return (
    <div style={{position:"fixed",bottom:0,left:0,right:0,background:C.surface,
      borderTop:`1px solid ${C.border}`,display:"flex",zIndex:100,
      paddingBottom:"env(safe-area-inset-bottom)",
      boxShadow:"0 -4px 20px rgba(0,0,0,0.08)"}}>
      {tabs.map(t=>{
        const on = active===t.id;
        return (
          <button key={t.id} onClick={()=>go(t.id)}
            style={{flex:1,border:"none",background:"none",cursor:"pointer",
              padding:"12px 0 8px",display:"flex",flexDirection:"column",
              alignItems:"center",gap:3}}>
            <div style={{fontSize:20,lineHeight:1,
              filter:on?"none":"grayscale(1)",opacity:on?1:0.4}}>{t.icon}</div>
            <span style={{fontSize:10,fontWeight:on?700:500,
              color:on?C.accent:C.muted,
              fontFamily:"-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif"}}>
              {t.label}
            </span>
            {on&&<div style={{width:4,height:4,borderRadius:"50%",background:C.accent}}/>}
          </button>
        );
      })}
    </div>
  );
};
